import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioOnlyIconErrorFn = /* @__PURE__ */ createRecipe('radio-icon-error', {}, [])

const radioOnlyIconErrorVariantMap = {}

const radioOnlyIconErrorVariantKeys = Object.keys(radioOnlyIconErrorVariantMap)

export const radioOnlyIconError = /* @__PURE__ */ Object.assign(memo(radioOnlyIconErrorFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioOnlyIconError',
  __getCompoundVariantCss__: radioOnlyIconErrorFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioOnlyIconErrorVariantKeys,
  variantMap: radioOnlyIconErrorVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioOnlyIconErrorVariantKeys)
  },
  getVariantProps: radioOnlyIconErrorFn.getVariantProps,
})